module.exports = __webpack_public_path__ + "static/img/strona_start.bec8ff60.jpg";